const LETTER_COUNT = 2;
const DIGIT_COUNT = 8; 
const CHAR_CODE_UPPERCASE_A = 65;
const UPPERCASE_ALPHABET_SIZE = 26;
const DECIMAL_DIGIT_BASE = 10;

export function generateUserId(): string {
  // Use crypto.getRandomValues for cryptographically secure random values
  const letterBytes = new Uint8Array(LETTER_COUNT);
  crypto.getRandomValues(letterBytes);
  const letters = Array.from(letterBytes, (b) => String.fromCharCode(CHAR_CODE_UPPERCASE_A + (b % UPPERCASE_ALPHABET_SIZE))).join('');
  const digitBytes = new Uint8Array(DIGIT_COUNT);
  crypto.getRandomValues(digitBytes);
  const digits = Array.from(digitBytes, (b) => (b % DECIMAL_DIGIT_BASE).toString()).join('');
  return `${letters}${digits}`;
}

export function ensureUserIdCookie(): string {
  const entry = document.cookie.split('; ').find(c => c.startsWith('userId='));
  if (entry) {
    const v = entry.split('=')[1] || '';
    return v;
  }
  const id = generateUserId();
  document.cookie = `userId=${id}; Path=/; SameSite=Lax`;
  return id;
}

// Alias for backwards compatibility with prior naming in UserContext
export function getOrCreateUserId(): string {
  return ensureUserIdCookie();
}
